import { FontIcon } from '../FontIcon';
import { ImageContainer } from '../ImageContainer';
import { LazyImage } from '../LazyImage';
import { Skeleton } from '../Skeleton';
import styles from './detailed.module.sass';
import cn from 'classnames';

interface BaseProps extends React.HTMLAttributes<HTMLDivElement> {
    isLoading?: boolean;
}

interface LoadingProps extends BaseProps {
    isLoading: true;
    picture?: string; // Optional when loading
    heading?: string | React.ReactElement;
    channelLogo?: string;
    info?: string[];
    channelRatio?: number;
    locked?: boolean;
}

interface LoadedProps extends BaseProps {
    isLoading?: false;
    picture: string; // Required when not loading
    heading: string | React.ReactElement;
    channelLogo?: string;
    info?: string[];
    channelRatio?: number;
    locked?: boolean;
}

type DetailedPosterProps = LoadingProps | LoadedProps;

export const DetailedPoster = ({
    picture,
    heading,
    channelLogo,
    info,
    channelRatio,
    locked,
    isLoading,
    ...props
}: DetailedPosterProps) => {
    if (isLoading) {
        return (
            <div {...props} className={cn(styles.detailed, props.className)}>
                <Skeleton absolute />
            </div>
        );
    }

    return (
        <div
            {...props}
            className={cn(styles.detailed, props.className)}
            {...(props.onClick && { style: { cursor: 'pointer' } })}
        >
            {locked && (
                <div className={cn(styles.locked)}>
                    <FontIcon name="lock" size="x-small" md="smaller" />
                </div>
            )}
            <LazyImage src={picture} className={styles.picture} />
            {channelLogo && (
                <div className={styles.provider}>
                    <ImageContainer src={channelLogo} ratio={channelRatio ? channelRatio : 1.5} alignment="start" />
                </div>
            )}
            <div className={styles.holder}>
                {typeof heading == 'string' ? <strong className={styles.title}>{heading}</strong> : heading}
                {info && (
                    <div className={styles.info}>
                        {info.map((item, index) => (
                            <span key={index}>{item}</span>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};
